module.exports = __webpack_public_path__ + "img/GabrielleNadeauArt-Monster-Green-Guy-Web-1280.23c22673.jpg";